<template>
  <div>
    <vue-html2pdf
      :show-layout="true"
      :float-layout="false"
      :enable-download="true"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      filename="Rapor"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="landscape"
      pdf-content-width="auto"
      ref="html2Pdf">
      <section slot="pdf-content">
        <div class="reportHeader">
          <img src="../../../../assets/img/reportLogo.png" class="logo" alt="SanatTeknoloji" width="300" style="padding: 1rem">
          <div class="info" style="width: 50%">
            <ul>
              <li> <strong> Sanat Teknoloji </strong></li>
              <li> <strong> Adres: </strong> Atakent Mah., Atakan Cad., Öncü Sok. 9/A, 34760 Ümraniye/İstanbul </li>
              <li> <strong> Telefon: </strong> 0850 259 00 99 </li>
              <li> <strong> E-posta: </strong> destek@sanatteknoloji.com.tr </li>
              <li> <strong> Web Sitesi: </strong> <a target="_blank" href="https://sanatteknoloji.com.tr/"> sanatteknoloji.com.tr </a> </li>
            </ul>
          </div>
        </div>
        <div class="report-details">
          <div class="head">
            <div v-if="ticketType.sub" class="title"> {{data.ticket.title}} - {{data.ticket.customer_sub.subscription_name}} </div>
            <div v-else class="title"> {{data.ticket.title}} - {{data.ticket.customer_product.product_name}} </div>
            <div class="info">
              <ul>
                <li v-if="ticketType.sub"> <strong> Abonelik: </strong> {{data.ticket.customer_sub.subscription_name}} </li>
                <li v-else> <strong> Ürün: </strong> {{data.ticket.customer_product.product_name}} </li>
                <li> <strong> Müşteri: </strong> {{data.ticket.customer.name}} </li>
                <li> <strong> Oluşturma Tarihi: </strong> {{moment(data.ticket.created_at)}} </li>
              </ul>
            </div>
          </div>
          <div class="body">
            <div class="title">Detaylar</div>
            <b-table-simple hover responsive style="min-height: 0 !important">
              <b-tbody>
                <b-tr> 
                  <b-td> <strong> Durum </strong> </b-td>
                  <b-td> {{data.ticket.status.description}} </b-td>
                  <b-td>
                    <b-icon v-if="data.ticket.status.id != 1" icon="check" variant="success" shift-v="1.25" scale="1.5" aria-hidden="true" />
                    <b-icon v-else icon="exclamation-triangle-fill" variant="warning" shift-v="1.25" scale="1.25" aria-hidden="true" />
                  </b-td>
                </b-tr>
                <b-tr> 
                  <b-td> <strong> Atanan </strong> </b-td>
                  <b-td> {{data.ticket.assigned_user}} </b-td>  
                  <b-td>
                    <b-icon v-if="data.ticket.assigned_user != 'Atanmadı'" shift-v="1.25" icon="check" variant="success"  scale="1.5" aria-hidden="true" />
                    <b-icon v-else icon="x" variant="danger"  scale="1.5" shift-v="1.25" aria-hidden="true" />
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple> 
          </div>
          <div class="comments">
            <div class="title">Yorumlar</div>
            <CommentCard
              v-for="comment in comments" 
              :key='comment.id'
              :comment='comment'
              :report="true"
            />
          </div>
        </div>
      </section>
    </vue-html2pdf>
  </div> 
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf'
import moment from 'moment'
import CommentCard from '../components/CommentCard'

export default {
  name: "TicketReport",
  props: {
    data: Object,
    modalName: String,
    modalEvent: Function,
    save: Boolean,
    saveState: Function,
    formName: String
  },
  components: {
    VueHtml2pdf,
    CommentCard
  },
  computed: {
    ticketType() {
      return this.data.ticket.customer_sub.id ? 
      { sub: true, name: 'Abonelik' } :
      { sub: false, name: 'Ürün' }
    },
    comments() {
      return this.$store.getters.getTicketComments
    }
  },
  methods: {
    moment: function (date) {
      return moment(date.substring(0,19)).format('DD MMMM YYYY HH:mm:ss');
    },
  },
  watch: {
    save: async function(data){
      if(data) {
        this.$refs.html2Pdf.generatePdf()
      }
      this.saveState(false)
    },
  },
  created() {
    this.$store.dispatch('fetchComments', this.data.ticket.id)
  }
}
</script>

<style lang="css" scoped > 
  @import "../styles/report.min.css"; 
</style>



// WEBPACK FOOTER //
// src/pages/Support/Ticket/modals/Report.vue